@use "../../styles/responsive";

$component-name: "vertical-stack";
$alignments: start, center, end, space-around, space-between, space-evenly;
$inline-alignments: start, center, end, baseline, stretch;

.verticalStack {
  display: flex;
  flex-direction: column;

  @include responsive.responsive-props($component-name, "gap", "gap");

  &.itemsReverse {
    flex-direction: column-reverse;
  }

  &.align {
    @each $alignment in $alignments {
      &-#{$alignment} {
        justify-content: $alignment;
      }
    }
  }

  &.inline-align {
    @each $alignment in $inline-alignments {
      &-#{$alignment} {
        align-items: $alignment;
      }
    }
  }

  &[hidden] {
    display: none;
  }
}
